import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // On first navigation after page load, restore session from HttpOnly cookie
  if (!authService.isInitialized()) {
    await authService.init();
  }

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  // Only redirect to onboarding if not already heading there.
  // login() already routes new users to /onboarding — duplicating that
  // redirect here creates a same-URL loop that stalls navigation.
  if (!authService.notificationsConfigured() && state.url !== '/onboarding') {
    return router.createUrlTree(['/onboarding']);
  }

  return true;
};
